import styled, { css } from 'styled-components';
import { toRem } from '../../utils/toRem';
import { palette } from '../../theme/colors';

const bgColor = 'rgba(128,168,237, 0.12)';

export const SContainer = styled.div<{ $variant?: 'notice' | undefined }>`
  background-color: ${props => (props.$variant === 'notice' ? palette.cloudBurst : bgColor)};
  border-radius: 1.5rem;
  padding: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: ${props => (props.$variant === 'notice' ? '1rem 7% 0 7%' : '0')};

  &.cursor-pointer {
    cursor: pointer;
  }
`;

export const SInfoContainer = styled.div<{ $variant?: 'notice' | undefined }>`
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props =>
    props.$variant === 'notice' ? palette.honeyYellow : palette.scienceBlue};
  flex-shrink: 0;
`;

export const STextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.25rem;
`;

export const STitle = styled.p<{ $variant?: 'notice' | undefined }>`
  font-size: ${toRem(14)};
  font-weight: 700;
  font-family: 'Roboto-Medium';
  line-height: ${toRem(18)};
  color: ${props => (props.$variant === 'notice' ? palette.white : palette.portage)};
  margin: 0;
`;

export const SText = styled.p<{ $variant?: 'notice' | undefined }>`
  font-size: ${toRem(14)};
  line-height: ${toRem(18)};
  color: ${props => (props.$variant === 'notice' ? palette.honeyYellow : palette.portage)};
  margin: 0;
`;

export const SArrowContainer = styled.div<{ $variant?: 'notice' | undefined }>`
  padding: ${props => (props.$variant === 'notice' ? `${toRem(10)}` : `${toRem(7)} ${toRem(10)}`)};
  border-radius: ${props => (props.$variant === 'notice' ? '50%' : toRem(14))};
  background-color: ${palette.whiteWith10Opacity};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  ${props =>
    props.$variant === 'notice' &&
    css`
      svg {
        width: ${toRem(18)};
        height: ${toRem(18)};
      }
      path {
        fill: #5c6b80;
      }
    `}
`;
